// extracted by mini-css-extract-plugin
export default {"root":"HIsVgIvm2x4gyqKkvXEA","main":"CjyF501hKMJJ8RU2f0g9"};